import React from 'react';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import {Box, Image, Text, VerticalDivider} from '../../../../styled';
import JiraStatus from './JiraStatus';
import {SimpleLink} from './styled';


const PreviewTitle = ({ item }: any) => {
  const { project, issuetype } = item.fields;
  return (
    <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
      <HighlightMarker>
        <Box display="flex" alignItems="center" justifyContent="flex-start" marginBottom="1rem">
          <Image src={project.avatarUrls['24x24']} height={24} width={24} marginRight="5px" alt="Jira project icon" />
          <SimpleLink href={`${item.jiraLink}/browse/${project.key}`} target={'jira'} fontSize={20} >
            {project.name}
          </SimpleLink>
          <VerticalDivider height={18} />
          {item.issueParent && (
            <>
              <Image src={item.issueParent.iconUrl} height={24} width={24} marginRight="5px" alt="Jira project icon" />
              <SimpleLink href={item.issueParent.link} target={'jira'} fontSize={20} >
                {item.issueParent.name}
              </SimpleLink>
              <VerticalDivider height={18} />
            </>
          )}
          <Image src={issuetype.iconUrl} height={24} width={24} marginRight="5px" alt="Jira project icon" />
          <SimpleLink href={item.permalink} target={'jira'} fontSize={20}>
            {item.key}
          </SimpleLink>
        </Box>
        <JiraStatus status={item.statusName} />
      </HighlightMarker>
      <div>
        <Text variant="muted" style={{ maxWidth: '100%' }}>
          {new Date(item.date).toLocaleDateString()}
        </Text>
      </div>
    </Box>
  )
}

export default PreviewTitle;